<ng-container *ngFor="let tagGroup of tagsContext.allTagGroups">
  <app-select-tag
    *ngIf="tagGroup.isVisibleAndNotRouting"
    [group]="tagGroup"
    [tagsContext]="tagsContext"></app-select-tag>
</ng-container>
